import { EmailTemplateData } from './email-template-dialog.component';

export class EmailTemplate {
  // DO NOT TOUCH THE FORMATTING OF THIS STRING
  public static generateTemplate = (
    data: EmailTemplateData,
  ) => `Dear ${data.rfxMetaData.competingSecondaryDisplayValue},

We are currently looking for opportunities to convert products under your Vizient contract ${data.rfxMetaData.competingDisplayValue}.

Attached is a list of products that need validation. Please review and confirm that the current cross-references are still accurate and provide an updated cross-reference for any products that do not have one or where the existing cross is no longer valid.

Attachment includes:
-  ${data.incompleteProductCount} incomplete products from ${data.rfxMetaData.selectedClientCount} members
-  Products are sorted ascending by spend

Please send the completed cross-reference file to CrossRefIntake@vizientinc.com

Thank you,
`;
}
